// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'speaker-on-sold';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path
      fill='currentColor'
      d='M5.154 6.875h-3.06a.531.531 0 0 0-.531.531v3.188a.531.531 0 0 0 .53.531h3.061a5.846 5.846 0 0 0 4.855 3.69.532.532 0 0 0 .585-.529V3.714a.533.533 0 0 0-.585-.529 5.847 5.847 0 0 0-4.855 3.69z'
    />
    <path d='M15.703 11.515a4.67 4.67 0 0 0 0-5.03m-2.055 4.102a2.473 2.473 0 0 0 0-3.116' />
  </g>
);

export const viewBox = '0 0 18 18';
